import { LabelDTO } from '@ketch-com/figurehead'

export const getLabelDTOUniqueIdentifier = (label: LabelDTO) =>
  `${label?.code || ''}${label?.value || ''}${label?.name || ''}`
